// extracted by mini-css-extract-plugin
export default {"nav":"nav___ZxLbi","scrolled":"scrolled___I8BFd","transparent":"transparent___L0vWt","container":"container___TQNZW","logo":"logo___YBXw2","auto_height":"auto_height___QLRCr"};